import { useEffect } from "react";
import { useDecisioningPanel } from "./DecisioningPanelContext";

/** Closes the open sheet when the item it edits is gone. */
export const CloseWhenMissing = () => {
	const { closeSheet } = useDecisioningPanel();
	useEffect(() => closeSheet(), [closeSheet]);
	return null;
};
